import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../src/environments/environment";
import { Counterpart } from "../model/domain/Counterpart";
import { CounterpartAccount } from "../model/domain/CounterpartAccount";
import { PagedList } from "../model/domain/PagedList";

@Injectable({
  providedIn: "root",
})
export class Counterpartservice {
  constructor(private http: HttpClient) {}

  GetCounterparts(
    name: string = null,
    document: string = null,
    page: number = null,
    pageSize: number = null
  ) {
    let url = `${environment.apiUrls.tickets}/ticket/counterpart-list`;

    const params: any = {};
    if (page != null) {
      params.page = page;
    }

    if (pageSize != null) {
      params.pageSize = pageSize;
    }

    if (name != null) {
      params.name = name;
    }

    if (document != null) {
      params.document = document;
    }

    return this.http.get<PagedList<Counterpart>>(url, {
      params,
    });
  }

  UpdateCounterpart(id: number, data: Counterpart) {
    return this.http.put(
      `${environment.apiUrls.tickets}/ticket/counterpart/${id}`,
      data
    );
  }

  GetCounterpart(id: number) {
    return this.http.get<Counterpart>(
      `${environment.apiUrls.tickets}/ticket/counterpart/${id}`
    );
  }

  RegisterUCounterpart(counterpart: Counterpart) {
    return this.http.post(
      `${environment.apiUrls.tickets}/ticket/counterpart/`,
      counterpart
    );
  }

  UpdateCounterpartAccount(counterpartAccount: CounterpartAccount[]) {
    return this.http.post(
      `${environment.apiUrls.tickets}/ticket/counterpart-account/`,
      counterpartAccount
    );
  }
}
